import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import * as yup from "yup";
import {
  getSafeStock,
  saveSafeStock,
} from "../../../../../services/inventory/safeStockService";
import { useGlobalData } from "../../../../../../provider/GlobalDataProvider";

import AppForm from "../../../../../partials/content/Forms/AppForm";
import SafeStockFormContent from "./SafeStockFormContent";
function SafeStockForm({
  warehouseID: warehouseIDprop = 0,
  outletID: outletIDprop = 0,
  match,
}) {
  const { reload } = useGlobalData();
  const [items, setItems] = useState([]);
  let warehouseID = 0;
  let outletID = 0;
  if (warehouseIDprop > 0) {
    warehouseID = warehouseIDprop;
  } else {
    const { warehouseID: warehouseIDparam = 0 } = match.params;
    warehouseID = parseInt(warehouseIDparam);
  }
  if (outletIDprop > 0) {
    outletID = outletIDprop;
  } else {
    const { outletID: outletIDparam = 0 } = match.params;
    outletID = parseInt(outletIDparam);
  }
  useEffect(() => {
    getSafeStockData(warehouseID, outletID);
  }, [warehouseID, outletID, reload]);
  return (
    <AppForm
      initialValues={items}
      onSubmit={(values, { resetForm, setStatus, setSubmitting }) => {
        Swal.mixin({
          customClass: {
            confirmButton: "btn btn-success btn-md btn-pill btn-bold",
            cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
          },
          buttonsStyling: false,
        })
          .fire({
            title: "Are you sure want to save this Safe Stock ?",
            text: "Please note that you are responsible for this action",
            icon: "question",
            showCloseButton: true,
            showCancelButton: true,
            confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, save it`,
            cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
            reverseButtons: true,
          })
          .then((result) => {
            if (result.isConfirmed) {
              saveSafeStock(values).then((response) => {
                Swal.mixin({
                  customClass: {
                    confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                  },
                  buttonsStyling: false,
                }).fire({
                  title: "Saved",
                  html: response.data.message,
                  icon: "success",
                  showCloseButton: true,
                  confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                });
                getSafeStockData(warehouseID, outletID);
              });
            } else if (result.dismiss === Swal.DismissReason.cancel) {
              Swal.mixin({
                customClass: {
                  confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                },
                buttonsStyling: false,
              }).fire({
                title: "Cancelled",
                text: "No change has been made",
                icon: "info",
                showCloseButton: true,
                confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
              });
            }
          });
      }}
    >
      <SafeStockFormContent
        warehouseID={warehouseID}
        outletID={outletID}
        onReloadSafeStock={() => {
          getSafeStockData(warehouseID, outletID);
        }}
      />
    </AppForm>
  );

  async function getSafeStockData(warehouseID = 0, outletID = 0) {
    const response = await getSafeStock(warehouseID, outletID);
    const { data } = response.data;
    setItems(data.itemsMaster);
  }
}

export default SafeStockForm;
